export const SEND_MAGIC_LINK_FORM_ID = 'send-magic-link-form-title';
export const TITLE_ID = 'form-title';
